import React, { Component } from "react";
import { connect } from "react-redux";
import Button from "react-bootstrap-button-loader";
import { COMMON_FAIL_MESSAGE } from "Constants";
import {
  toggleEditSEOCodeEditor,
  validateSEOCode,
  updateSEOCode,
} from "GeneralTabAction";
import { showError } from "ReduxErrorBar";
import { fetchEvent } from "ActionsMessage";
import LocaleStrings from "Languages";
import { Col, Row } from "react-bootstrap";

class EditSEOName extends Component {
  constructor(props) {
    super(props);
    this.state = { loading: false, oldseocode: "", newseocode: "" };
  }

  componentDidMount() {
    let { initialValues } = this.props;

    this.setState({
      oldseocode: initialValues.seocode,
      newseocode: initialValues.seocode,
    });
  }

  changeSeoCode = (e) => {
    let value = e.target.value;
    value =
      value.replace(/\s+/g, "") && value.replace(/[^\w]|_/g, "").toLowerCase();
    // value = value.replace(/[^\w]|_/g, '').toLowerCase()
    // value = value.replace(/\s+/g, '')

    this.setState({
      newseocode: value,
    });
  };

  onFormSubmit = () => {
    let { session, eventData } = this.props;
    let { oldseocode, newseocode } = this.state;
    let secocode = newseocode.trim();

    if (oldseocode != newseocode) {
      let values = { seocode: secocode };
      this.setState({ loading: true });

      this.props.validateSEOCode(session, secocode, (response) => {
        if (response.success === 2) {
          this.setState({ loading: false });
          this.props.showError(
            LocaleStrings.general_form_label_event_seocode_not_available
          );
        } else if (response.success === 1) {
          this.props.updateSEOCode(
            session,
            values,
            eventData.eventid,
            (response) => {
              if (response.success == 1) {
                this.props.fetchEvent(this.props.session);
                setTimeout(() => {
                  this.setState({ loading: false });
                  this.props.toggleEditSEOCodeEditor(false);
                }, 500);
              } else if (response.success == 2) {
                this.setState({ loading: false });
                this.props.showError(
                  LocaleStrings.general_form_label_event_seocode_not_available
                );
              } else {
                this.setState({ loading: false });
                this.props.showError(COMMON_FAIL_MESSAGE);
              }
            }
          );
        } else {
          this.setState({ loading: false });
          this.props.showError(COMMON_FAIL_MESSAGE);
        }
      });
    }
  };

  closeEdit() {
    this.props.toggleEditSEOCodeEditor(false);
  }

  render() {
    let { oldseocode, newseocode, loading } = this.state;
    let disabled =
      oldseocode === newseocode || newseocode == "" || loading ? true : false;

    var divClassName = `form-group seo-edit-box ${
      newseocode == "" ? "has-danger" : ""
    }`;
    var inputClasses = "col-sm-7 col-sm-offset-0 iconfield";

    return (
      <Row>
        <Col md={7}>
          <div
            className={divClassName}
            style={{ marginBottom: 0, marginTop: 0 }}
          >
            <div
              className={inputClasses}
              // style={{ marginTop: "3px", zIndex: 1, width: "inherit" }}
            >
              <input
                className="form-control"
                type="text"
                value={newseocode}
                onChange={this.changeSeoCode}
                autoFocus="autofocus"
              />
              <div className="static-eventifyio">.eventify.io</div>

              <div className="text-help label-text-help mt-2">
                {newseocode == ""
                  ? LocaleStrings.general_form_label_event_seocode_error1
                  : ""}
              </div>
            </div>
          </div>
        </Col>
        <Col md={5}>
          <Button
            className="btn btn-i-custom-blue"
            onClick={this.onFormSubmit}
            disabled={disabled}
            loading={loading}
          >
            <i className="fa fa-save"></i>
          </Button>
          <button
            type="button"
            className="i-custom-table-delete"
            style={{ marginLeft: 5, marginTop: 4 }}
            onClick={this.closeEdit.bind(this)}
          >
            {/* <span aria-hidden="true">×</span> */}
            <img src="../../style/images/custom-icons/shape-1317-copy-3.svg" />
          </button>
        </Col>
      </Row>
    );
  }
}

function mapStateToProps(state, ownProps) {
  return {
    session: state.session,
    initialValues: { seocode: ownProps.eventData.seocode },
    eventData: ownProps.eventData,
  };
}

export default connect(mapStateToProps, {
  toggleEditSEOCodeEditor,
  validateSEOCode,
  updateSEOCode,
  fetchEvent,
  showError,
})(EditSEOName);
